<template>
    <div class="car-quote-step driver-info">
        <quote-step-header
            :key="currentSubStep"
            :currentStep="currentSubStep + 1"
            :subtitle="subStepFields.subtitle"
            :title="subStepFields.title"
            :totalSteps="step.totalSteps"
        ></quote-step-header>
        <form class="quote-form" @submit.prevent="next">
            <div class="form-row center">
                <app-text-radio-buttons
                    v-model="form[stepName].number"
                    :break-mobile="true"
                    :items="driverNumber"
                    :message="errors.get('number')"
                >
                </app-text-radio-buttons>

                <div
                    class="flex flex-col md:flex-row mb-5 md:mb-0 md:mt-5 gap-5 md:gap-10 w-full"
                >
                    <app-autocomplete-input
                        label="inputs.city"
                        :message="errors.get('city')"
                        :search-cb="searchCities"
                        @reset="resetCity"
                        v-model="form[stepName].city"
                        class="flex-1"
                    />

                    <app-autocomplete-input
                        label="inputs.street"
                        :message="errors.get('street')"
                        :search-cb="searchStreets"
                        v-model="form[stepName].street"
                        class="flex-1"
                    />
                </div>

                <template v-if="form[stepName].number">
                    <div class="driver-details-wrap md:mt-10">
                        <div class="driver-blocks">
                            <app-driver-info
                                :constants="constants"
                                :disabled="form[stepName].youngestMainDriver"
                                :errors="errors"
                                :trans="trans"
                                v-model="form[stepName].youngestDriver"
                                errorKey="youngestDriver"
                                :subTitle="'younger_driver'"
                                :isFirst="true"
                            ></app-driver-info>
                        </div>
                        <div class="driver-blocks">
                            <app-driver-info
                                v-if="showSecondDriver"
                                :constants="constants"
                                :errors="errors"
                                :trans="trans"
                                v-model="form[stepName].mainDriver"
                                errorKey="mainDriver"
                                subTitle="subtitle_second"
                            ></app-driver-info>
                        </div>
                    </div>
                </template>
            </div>

            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";
import AppAutocompleteInput from "../../Forms/AutocomplateInput";

export default {
    name: "CarQuoteDriverInfo",

    mixins: [QuoteStep],

    components: {
        AppAutocompleteInput
    },

    props: {},

    data() {
        return {
            subSteps: ["default"]
        };
    },
    methods: {
        resetCity() {
            // this.form.address.city = undefined;
        },
        async searchStreets(term) {
            const cityId = this.form[this.stepName].city.id;

            if (!term || !cityId || term.length < 2) {
                return [];
            }

            const res = await this.$api.get(
                "address/street/" + cityId + "/search?q=" + term
            );

            const items = res.data();

            return (items || []).map(city => ({
                value: city.code,
                id: city.id,
                label: city.name
            }));
        },
        async searchCities(term) {
            if (!term || term.length < 2) {
                return [];
            }

            const res = await this.$api.get("address/city/search?q=" + term);
            const items = res.data();

            return (items || []).map(city => ({
                value: city.code,
                id: city.id,
                label: city.name
            }));
        }
    },
    computed: {
        showSecondDriver() {
            // Determine if second driver should be shown
            const step = this.form[this.stepName];
            const isTwoDrivers = step.number === this.constants.DRIVERS_TWO;

            return isTwoDrivers;
        },

        hasYoungestErrors() {
            return (
                this.errors.get("youngestDriver.birth") ||
                this.errors.get("youngestDriver.sex") ||
                this.errors.get("youngestDriver.licenseIssued")
            );
        },
        driverNumber() {
            return [
                {
                    label: this.trans("single_driver"),
                    value: this.constants.DRIVERS_ONE,
                    icon: "wheel",
                    icon_checked: "wheel_checked",
                    icon_amount: 1
                },
                {
                    label: this.trans("two_drivers"),
                    value: this.constants.DRIVERS_TWO,
                    icon: "wheel",
                    icon_checked: "wheel_checked",
                    icon_amount: 2
                },
                {
                    label: this.trans("any_driver"),
                    value: this.constants.DRIVERS_ANY,
                    icon: "wheel",
                    icon_checked: "wheel_checked",
                    icon_amount: 2
                }
            ];
        },
        canMoveNext() {
            switch (this.subStep) {
                case "number": {
                    const driverNumber = [
                        this.constants.DRIVERS_ONE,
                        this.constants.DRIVERS_TWO,
                        this.constants.DRIVERS_ANY
                    ];

                    return driverNumber.includes(this.stepFormFields.number);
                }
            }

            return true;
        }
    }
};
</script>

<style lang="scss">
.driver-info {
    width: $quote-step-width;

    .new-driver-wrap {
        margin: 27px auto 0 auto;
        max-width: 618px;
        width: 100%;
        height: 131px;
        background-color: $pale-blue;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}

.driver-details-wrap {
    width: 100%;

    .second_header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .second_header--title {
            color: $black;
            text-align: center;
            font-size: $font-size-desktop;
            font-weight: $font-bold;

            @media screen and (max-width: $mobile) {
                font-size: $font-size-mobile;
            }
        }

        .second_header--subtitle {
            color: rgba(0, 0, 0, 0.4);
            text-align: center;
            font-size: 25px;
            font-weight: $font-normal;

            @media screen and (max-width: $mobile) {
                font-size: $font-size-mobile;
                color: $black;
                font-weight: $font-light;
            }
        }
    }

    @media screen and (max-width: $mobile) {
        margin-top: 0;
    }

    .driver-blocks {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        .app-quote-radio-buttons label {
            @media screen and (max-width: $mobile) {
                height: 40px;
            }
        }
    }

    .youngest-invalid-data {
        text-align: center;
        margin-top: 25px;
        margin-bottom: -20px;
        font-size: 21px;

        span {
            font-weight: bold;
            cursor: pointer;
        }
    }

    .youngest-is-main-checkbox {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
    }
}
</style>
